export default {
  de: {
    title: 'Neuen Wahltyp hinzufügen',
    name: 'Name',
    submit: 'Wahltyp erstellen',
    back: 'Zurück',
    alerts: {
      500: () => 'Ein unbekannter Fehler ist aufgetretten! Bitte versuchen Sie es in kürze erneut!',
    },
  },
};
